import NotificationVirtualAttendance from "views/components/AttendanceList/NotificationVirtualAttendance/NotificationVirtualAttendance";
import { Header } from "views/components/AttendanceList/styles";

const HeaderComponent = ({
    dataAcadReinforce
}) => {
    if (!dataAcadReinforce) return null;
    const { title, date, time, isPresential } = dataAcadReinforce;
    return (
        <Header>
            <h2>Asistencia de alumnos</h2>
            <h3>{title}</h3>
            {date && 
            <h4>
                Fecha: {date} / Hora: {time}
            </h4>}
            {!isPresential && <NotificationVirtualAttendance/>}
        </Header>
    );
}

export default HeaderComponent;